let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");

let WarnOfUnsavedChangesModal = dd.createClass({
	render(){
		let {onSave, onClose, onDiscard} = this.props;
		return Modal({
				title: "Unsaved changes",
				buttons: [],
				onClose
			},
			dd.div({className: "row"},
				dd.div({className: "col-sm-3 text-center text-muted"},
					dd.i({className: "fa fa-warning", style: {fontSize: 60}})
				),
				dd.div({className: "col-sm-9"},
					dd.p(null,
						"You have some changes that are not saved."
					),
					dd.p(null,
						onSave
							? "Would you like to save them?"
							: "Would you like to go back and save them?"
					),
					dd.br()
				)
			),
			dd.div({className: "text-center"},
				onSave
					? dd.button({className: "btn btn-primary", onClick: onSave},
							"Yes, save"
						)
					: dd.button({className: "btn btn-primary", onClick: onClose},
							"Yes, go back so I can save"
						),
				" ",
				dd.button({className: "btn btn-default", onClick: onDiscard},
					"No, don't save"
				)
			)
		);
	}
});

let IncomingChangesModal = dd.createClass({
	render(){
		let {onClose, message} = this.props;
		return Modal({
				title: "Incoming Changes",
				buttons: [],
				onClose
			},
			dd.div({className: "row"},
				dd.div({className: "col-sm-3 text-center text-muted"},
					dd.i({className: "fa fa-warning", style: {fontSize: 60}})
				),
				dd.div({className: "col-sm-9"},
					dd.p({className: "preserve-whitespace"},
						message
					),
					dd.br()
				)
			),
			dd.div({className: "text-center"},
				dd.button({className: "btn btn-primary", onClick: onClose}, "Ok")
			)
		);
	}
});

module.exports = dd.createClass({
	mixins: [RadioMixin],
	getInitialState(){
		return {
			continuation_fn: null,
			cancel_fn: null,
			unsaved_changes: {},
			saving_state: null,
			incoming_changes_message: null
		};
	},
	Radio_setup(){
		return {
			checkUnsavedEventChangesBeforeContinuing(eid, continuation_fn, cancel_fn){
				let saveFns = this.__getSaveFns();
				if(_.size(saveFns) > 0){
					this.setState({
						continuation_fn: continuation_fn,
						cancel_fn: cancel_fn
					});
				}else{
					continuation_fn();
				}
			},
			eventFormUnsavedState(eid, form_id, fn_to_save_the_changes){
				let unsaved_changes = this.state.unsaved_changes || {};
				let made_a_change = false;

				if(fn_to_save_the_changes){
					if(!_.has(unsaved_changes, eid)){
						unsaved_changes[eid] = {};
						made_a_change = true;
					}
					if(!_.has(unsaved_changes[eid], form_id)){
						unsaved_changes[eid][form_id] = fn_to_save_the_changes;
						made_a_change = true;
					}
				}else{
					if(_.has(unsaved_changes, eid) && _.has(unsaved_changes[eid], form_id)){
            delete unsaved_changes[eid][form_id];
						made_a_change = true;
					}
					if(_.size(unsaved_changes[eid]) === 0){
						delete unsaved_changes[eid];
						made_a_change = true;
					}
				}
				if(made_a_change){
					this.setState({unsaved_changes: unsaved_changes});
				}
			},
			save_Event_succeeded(event, is_new, displaymessage){
				this.__clearUnsavedChangesForEID(event && event.eid);
			},
			loadedNewEventVersion_diff(diff, old_event, new_event){
				let eid = old_event.eid;
				let is_dirty = _.has(this.state.unsaved_changes, eid);
				if(!is_dirty){
					return;
				}
				let message = "Some changes were just made by ";
				if(_.isString(new_event.last_changed_by) && new_event.last_changed_by.length > 0){
					message += new_event.last_changed_by;
				}else{
					message += "another user";
				}
				message += ". These changes were just automatically synced and may have overwritten a field you are currently editing.\n\nPlease check the fields you last edited.";
				//TODO show the paths that were changed
				//_.each(diff.added, prPaths);
				//_.each(diff.changed, prPaths);
				//_.each(diff.removed, prPaths);
				this.setState({incoming_changes_message: message});
			}
		};
	},
	__clearUnsavedChangesForEID(eid, done){
		this.setState({unsaved_changes: _.omit(this.state.unsaved_changes, eid)}, done);
	},
	__continueToURL: esUtils.wrapPreventDefault(function(){
		let fn = this.state.continuation_fn;
		this.setState({continuation_fn: null, cancel_fn: null, unsaved_changes: {}}, function(){
			fn();
		});
	}),
	__getSaveFns(){
		return _.filter(_.flattenDeep(_.map(this.state.unsaved_changes, _.values)), _.isFunction);
	},
	__saveChanges: esUtils.wrapPreventDefault(function(){
		let self = this;
		this.setState({saving_state: {waiting: true, has_error: null}}, function(){
			let has_error = false;
			let onDone = function(){
				self.setState({saving_state: {waiting: false, has_error: has_error}}, function(){
					if(!has_error){
						self.__continueToURL();
					}
				});
			};
			let saveFns = self.__getSaveFns();
			if(_.isEmpty(saveFns)){//catching a race condition where save is clicked after the save action is no longer needed
				onDone();
				return;
			}
			let done = _.after(_.size(saveFns), onDone);
			_.each(saveFns, function(saveFn){
				saveFn(function(err){
					if(err){
						has_error = true;
					}
					done();
				});
			});
		});
	}),
	__closeUnsavedWarningURL: esUtils.wrapPreventDefault(function(){
		let fn = this.state.cancel_fn;
		this.setState({continuation_fn: null, cancel_fn: null, saving_state: null}, function(){
			fn();
		});
	}),
	__clearIncommingChangesMessage: esUtils.wrapPreventDefault(function(){
		this.setState({incoming_changes_message: null});
	}),
	render(){
		let saving_state = this.state.saving_state || {};
		if(saving_state.waiting){
			return Modal({title: "Saving...", buttons: []},
				LoadingWrap({is_loading: true, text: "Saving..."})
			);
		}
		if(saving_state.has_error){
			return Modal({
					title: "Failed to save",
					onClose: this.__closeUnsavedWarningURL
				},
				ErrorAlert({message: "Unable to save. Check your input."})
			);
		}
		if(this.state.incoming_changes_message){
			return IncomingChangesModal({
				message: this.state.incoming_changes_message,
				onClose: this.__clearIncommingChangesMessage
			});
		}
		if(this.state.continuation_fn){
			let saveFns = this.__getSaveFns();
			return WarnOfUnsavedChangesModal({
				onClose: this.__closeUnsavedWarningURL,
				onDiscard: this.__continueToURL,
				onSave: _.size(saveFns) > 1 ? null : this.__saveChanges//only do the save if there is only one save fn otherwise there are some nasty race conditions we don't have an easy way of dealing with yet
			});
		}
		return dd.span();
	}
});



// WEBPACK FOOTER //
// ./src/components/modals/WarnOfUnsavedChanges.js